import { render, staticRenderFns } from "./geographyTab.vue?vue&type=template&id=70adda32&scoped=true&"
import script from "./geographyTab.vue?vue&type=script&lang=js&"
export * from "./geographyTab.vue?vue&type=script&lang=js&"
import style0 from "./geographyTab.vue?vue&type=style&index=0&id=70adda32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70adda32",
  null
  
)

export default component.exports
import {QForm,QScrollArea,QInput,QSelect} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QScrollArea,QInput,QSelect})
